// export const API_BASE_URL =
//   process.env.API_BASE_URL || "https://kisaan-khata-api.updateproject.com";

  export const API_BASE_URL =
  // process.env.API_BASE_URL || "https://kisaan-khata-api.updateproject.com";
  process.env.API_BASE_URL || "https://api.kisaankhata.com";
  
//  CommonImgUploadService
// export const CommonImgUploadService_BASE_URL="https://updateproject.com/kisaan-khata-api/api/uploads"https://updateproject.com/kisaan-khata-api

export const QrcodeImgService_BASE_URL="https://api.kisaankhata.com"

export const CommonImgUploadService_BASE_URL="https://kisaankhata.com/api/uploads"

export const CommonImgUploadService_pdf_BASE_URL="https://kisaankhata.com/api"


export const X_API_KEY="z3rlamk8xyv4r79x5wb8t35x3ot49yzg"
// process.env.API_BASE_URL || "https://api.khatadarpan.in";
// export const CommonImgUploadService_BASE_URL="https://khatadarpan.in/api/uploads"
export const API_PATHS = {
  


  //authentication
  login: "/users/userlogin",
  updatelogin:"/client/updatepassword",
  checkprofile:"/client/checkprofile",
  sendOtp: "/send-otp",
  verifyOtpUpdatePassword: "/verify-otp-and-update-password",

  getledgergroups: "/common/getledgergroups",
  getledgerdetail:"/ledger/get-ledger-detail",
  getfinancialyear: "/client/get-financial-year",

  // pdf
  ledgerpdf:"/pdf-ledger",
  invoicespdf:"/pdf/invoices",
  quotationpdf:"/pdf/quotation",
  trialbalancepdf:"/pdf-trialbalance",
  profitandlossPdf:"/pdf-profitandloss",
  pdfbalancesheet:"/pdf-balance-sheet",
  pdfCashBook:"/pdf-cash-book",
  pdfpaymentreccont:"/pdf-payment-rec-cont/",
  pdfjournal:"/pdf-journal/",
  invoicesBulk:"/pdf-generate-invoices",
  pdfGeneratePurchaseVoucher: "/pdf-generate-purchase-voucher",
  purchaseVoucherpdf:"/pdf-purchase-voucher",
  paymentoutpdf:"/pdf/payment",
  creditnotepdf:"/pdf/credit-note",
  debitnotepdf:"/pdf/debit-note",

  GetSpecialOpeningBalance:"/ledger/get-opening-balance",
  updateOpeningBalanceAll:"/ledger/update-opening-balance",
  Groupledgers:"/ledger/group-ledgers",
  addgroup:"/ledger/add-group",
  getdefaultledgers:"/ledger/get-default-leadgers",
  updateledger:"/ledger/update",
  deleteledger:"/ledger/delete",
  getsettings:"/client/getsettings",
  getunits: "/common/getunits",
  updatesettings:"client/updatesettings/",
  addbank:"/client/add-bank-book",
  updatebank:"/client/edit-bank-book",


  getcompanybanks:"/client/get-company-banks/",
  getsinglebank:"/client/get-bank/",
  ledgerlist:"/ledger/list/",
  ledgeradd:"/ledger/add",
  ledgerentires:"/ledger/get-ledger-entires",
  Depositwithdraw:"/ledger/add-bank-entry",
  listcategories:"/items/list-categories",
  addcategory:"/items/add-category",
  additems:"/items/add",
  updateitems:"/items/update",
  listitems:"/items/list",
  edititems:"/items/get-detail",

  addparties:"/parties/add",
  updateparties:"/parties/update",
  partieslist:"/ledger/get-party-ledger-list",
  partiesEdit:"/parties/get-detail",
  synctoledger:"/parties/sync-to-ledger",
  getsingledetail:"/items/get-detail",
  getcurrentstock:"/report/get-current-stock",
  getinvoiceslistpayments: "invoice/list-payments",
  getinvoicesnextnumber:"/invoices/next-number",
  paymentmethods:"/client/payment-methods",
  getbycustomer:"/invoice/get-by-customer",
  invoiceslist:"/invoices/list",
  generateirn: "/invoice/generate-irn",
  addinvoicespayment:"/invoice/payment/add",
  addinvoices: "/invoices/add",
  getinvoicessingledetails:"/invoice/get",

  getsinglepaymentdetail:"/invoice/payment-detail",
  updatepayment:"/invoice/update-payment",
  getirndetail:"/invoice/getirndetail",
  
  // Directors 
  directorslist:"/directors/list",
  directorsStore:"/directors/add",
  directorsEdit:"/directors/detail",
  directorsUpdate:"/directors/update",
  directorsdelete:"/directors/delete",

  invoiceUpdate:"/invoice/update",

  // Proforma Invoice
  performaList: "/performa/list",
  performaNextNumber: "/performa/next-number",
  performaAdd: "/performa/add",
  performaDetail: "/performa/detail",
  performaCustomer: "/performa/customer",
  performaUpdate: "/performa/update",
  performaDelete: "/performa/delete",


  // farmer
  farmerlist :"/farmer/list",
  farmerAdd :"/farmer/add",
  farmerEdit :"/farmers/get-detail",
  farmerUpdate :"/farmer/update",
  farmerdelete :"/farmer/delete",
  farmerbulkdelete :"/farmer/bulkdelete",

  // Members
  memberslist :"/members/list",
  membersadd :"/members/add",
  membersedit :"/members/get-detail",
  membersupdate :"/members/update",
  membersdelete :"/members/delete",
  membersbulkdelete :"/members/bulkdelete",

  // Management Cost
  Managementedit :"/client/get-management-cost",
  Managementupdate :"/client/update-management-cost",

  // Management Cost Head (new endpoints)
  ManagementHeadAdd: "/management-cost-head/add",
  ManagementHeadList: "/management-cost-head/list",
  ManagementHeadUpdate: "/management-cost-head/update",
  ManagementHeadDetail: "/management-cost-head/detail",
  ManagementHeadDelete: "/management-cost-head/delete",

  // Management Cost (additional endpoints)
  ManagementCostAdd: "/management-cost/add",
  ManagementCostList: "/management-cost/list",
  ManagementCostDetail: "/management-cost/detail",
  ManagementCostUpdate: "/management-cost/update",

  // Share Applications
  ShareApplicationslist :"/share-applications/list",
  ShareApplicationsadd :"/share-applications/add",
  ShareApplicationsedit :"/share-applications/get-detail",
  ShareApplicationsupdate :"/share-applications/update",
  ShareApplicationsdelete:"/share-applications/delete",
  ShareApplicationsdeleteMultiple:"/share-applications/delete-multiple",
  ShareApplicationsConvertMember:"/share-applications/convert-member",
  ImportShareApplications:"/share-applications/import",  // Share Transfer

  // Equity Grants
  EquityGrantList: "/equity-grants/list",
  EquityGrantAdd: "/equity-grants/add",
  EquityGrantDetail: "/equity-grants/detail",
  EquityGrantDelete: "/equity-grants/delete",

  ShareTransferList :"/share-transfer/list",
  ShareTransferAdd :"/share-transfer/add",
  ShareTransferEdit :"/share-transfer/detail",
  ShareTransferUpdate :"/share-transfer/update",

 // ComapnyDucuments
  ComapnyDucumentsedit :"/client/documents",
  ComapnyDucumentsUpdate :"/client/upload-documents",

  // dividend
   DividendList :"/dividend/list",
   DividendAdd :"/dividend/add",
   DividendEdit :"/dividend/detail",
   DividendUpdate :"/dividend/update",

  //  loads
  LoansList :"/loans/list",
  LoansAdd :"/loans/add",
  LoansEdit :"/loans/detail",
  LoansUpdate :"/loans/update",


QuotationList : "quotation/list",
getQuotationnextnumber:"/quotation/next-number/",
addQuotation: "/quotation/add",
GetQuotationSingleDetails : "/quotation/get",
QuotationUpdate:"/quotation/update",





  // PurchaseService 
 addpurchaseorders: "/purchase-orders/add",
 purchaseorderslist:"/purchase-orders/list",
 singledetailspurchaseorders:"/purchase-orders/get",
 updatepurchaseorders :"/purchase-orders/update",
 add_tax:"/tax/list",

 createpurchasevoucher: "/purchase-invoice/add",
 purchasevouchelist:"/purchase-invoice/list",
 updatepurchasevoucher:"/purchase-invoice/update",
 GetPurchaseVoucherDetail:"/purchase-invoice/get",


 PaymentOutgetbycustomer:"/purchase-invoice/get-by-customer",
 addpaymentout:"/purchase-invoice/payment/add",
 paymentoutlist:"/purchase-invoice/list-payments",
 updatepaymentout:"/purchase-invoice/update-payment",
 getpaymentdetail:"/purchase-invoice/payment-detail",

//  debit Note

debitnotelist:"/debit-note/list",
adddebitnote:"/debit-note/add",
updatedebitnote:"/debit-note/update",
getsingledebitnote:"/debit-note/get",

creditnotelist:"/credit-note/list",
addcreditnote:"/credit-note/add",
updatecreditnote:"/credit-note/update",
getsinglecreditnote:"/credit-note/get",

updatecashopeningbalance:"/client/update-cash-opening-balance",
getdetailclients:"/clients/get-detail",

getstate:"/common/getstatelist",
Addjournalvoucher :"/journal-voucher/add",
journalvoucherlist:"/journal-voucher/list",
Updatejournalvoucher:"/journal-voucher/update",
getdetailjournalvoucher:"/journal-voucher/get-detail",

AddPaymentReceiptContra :"/payment-receipt-contra/add",
listPaymentReceiptContra:"/payment-receipt-contra/list",
GetdetailPaymentReceiptContra :"/payment-receipt-contra/edit",
UpdatePaymentReceiptContra : "/payment-receipt-contra/update",

// report
getplstatement:"/ledger/get-balancesheet",
stocksummary:"/report/stock-inventory",
trialbalance:"/ledger/trial-balance",
ProfitLoss:"/ledger/get-pl-statement",
getauditloglist:"/common/getauditloglist",
getauditlogdetail:"/common/getauditlogdetail",
CompliancesList:"/compliances/list",
addcompliance:"/compliance/add-client-compliance",
listcompliance: "/compliance/list-client-compliances",
lowstockitems:"/report/low-stock-items",
fastmovingitems:"/report/fast-moving-items",
gstr1:"/report/gstr1",
gstr2:"/report/gstr2",



InvoicePDF : "pdf/invoices/",

clientEdit: "/clients/get-detail",
clientUpdate: "/clients/update",


gettotalsales:"/dashboard/get-total-sales",
gettotalpurchase: "/dashboard/get-total-purchase",

gettotalbankbalance:"/dashboard/get-total-bank-balance",
gettotalcash:"/dashboard/get-total-cash",
gettotalsundrydebtors:"/dashboard/get-total-sundry-debtors",
gettotalsundrycreditors:"/dashboard/get-total-sundry-creditors",
stockinventorytotal:"/report/stock-inventory-total",
getshareholder:"/dashboard/get-share-holder-data",

ListAssets:"/assets/list",
AddAssets:"/assets/store",
EditAssets:"/assets/get-detail",
updateAssets:"/assets/update",


invoicesDelete :"/invoice/delete-invoice",
creditNoteDelete :"/credit-note/delete",
quotationDelete :"/quotation/delete",
Deleteitems : "/items/delete-item",
DeletePurchaseOrder : "/purchase-orders/delete",
DeletePurchasevoucher : "/purchase-invoice/delete",
DeletePurchasepayment : "/purchase-invoice/delete-payment",
debitNoteDelete : "/debit-note/delete",
invoicepaymentDelete : "/invoice/delete-payment",
JournalvoucherDelete : "/journal-voucher/delete",
updateopeningbalance:"ledger/update-opening-balance",
addclosingstock:"/closing-stock/add",
updateclosingstock:"/closing-stock/update",
closingstocklist:"/closing-stock/list",
deleteclosingstock:"/closing-stock/delete",
Getclosingstock:"/closing-stock/edit",
LedferGetCashID : "ledger/get-cash-ledger-id/",
clientUpdateBankDetail: "clients/clients-bank-detail",
uploadsignature:"/client/upload-signature",
getyearlysales:"/dashboard/get-yearly-sales",
getyearlypl:"/dashboard/get-yearly-pl",
invoicesbyitem:"/report/item-ledger ",


journalvoucherdelete:"/journal-voucher/delete",
paymentContradelete:"/payment-receipt-contra/delete",
importfarmer:"/farmer/import",
addUser:"/users/add",
listUser:"/users/list",
detailUser:"/users/detail",
usersupdate:"/users/update",
pendinginvoices:"/invoice/pending-invoices",
purchasependinginvoices:"/purchase-invoice/pending-invoices"


}